import { z } from 'zod';
import { taskSectionInput } from '../index.js';
export const taskTemplateApiRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId/task-template/:taskTemplateId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/task-templates',
        output: {},
    },
    create: {
        method: 'POST',
        path: '/organization/:organizationId/task-templates',
        input: z
            .object({
            title: z.string().optional().nullable(),
            description: z.string().optional().nullable(),
            recipientInstructions: z.string().optional().nullable(),
            config: z.optional(z.object({ sections: taskSectionInput }).nullable()),
        })
            .strict(),
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/task-template/:taskTemplateId',
        input: z
            .object({
            title: z.string().optional().nullable(),
            description: z.string().optional().nullable(),
            recipientInstructions: z.string().optional().nullable(),
            config: z.optional(z.object({ sections: taskSectionInput }).nullable()),
        })
            .strict(),
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId/task-template/:taskTemplateId',
        output: {},
    },
    createFromTask: {
        method: 'POST',
        path: '/organization/:organizationId/task-template/create-from-task/:taskId',
        input: z.object({
            title: z.string().min(1),
            description: z.string().optional().nullable(),
        }),
        output: {},
    },
};
//# sourceMappingURL=task-template-api-routes.js.map